import { Component, ElementRef, input, viewChild } from '@angular/core';

import { PrivaButtonComponent, PrivaButtonIconStateType } from '@priva/components/button';

@Component({
    selector: 'app-scan-button',
    templateUrl: './scan-button.component.html',
    styleUrl: './scan-button.component.scss',
    imports: [PrivaButtonComponent],
})
export class ScanButtonComponent {
    text = input('');
    iconState = input<PrivaButtonIconStateType>('none');
    iconClass = input('');
    isClickable = input(true);

    readonly scanBtn = viewChild.required('scanBtn', { read: ElementRef });

    onClick() {
        this.scanBtn().nativeElement.blur();
    }
}
